export const clearAccessTokenCookie = () => {
  const tokenCookie = useCookie('accessToken');
  tokenCookie.value = '';
};
